import { KeyboardAvailabilityService } from './keyboard-availability.service';
import { Inject, Injectable } from '@angular/core';
import { MousetrapWrapperService } from 'shared/services/mousetrap-wrapper/mousetrap-wrapper.service';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BcKeyboardService {
  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private KeyboardAvailabilityService: KeyboardAvailabilityService,
    private _mousetrap: MousetrapWrapperService
  ) {}

  bindGlobal(keyCombo, callback, options) {
    return this.bindToElement(keyCombo, callback, this._document.body, options);
  }

  bindToElement(keyCombo, callback, element, options) {
    if (element && element.tabIndex === undefined) {
      element.tabIndex = -1;
    }

    const wrappedCallback = this._wrapCallback(keyCombo, callback, options);
    return this._mousetrap.bind(keyCombo, wrappedCallback, element);
  }

  _wrapCallback(keyCombo, callback, options) {
    // jwerty supports boolean parameters as callback, as if a function was returning them
    if (callback === true || callback === false) {
      return callback;
    }

    return (event) => {
      if (this.KeyboardAvailabilityService.areShortcutsAllowed) {
        if (!this.KeyboardAvailabilityService.isShortcutDisabled(keyCombo)) {
          if (options && options.stopEvent) {
            event.stopPropagation();
            event.preventDefault();
          }

          callback(event);
        }
      }
    };
  }
}
